import React, { useState } from 'react';

interface TooltipProps {
  label: React.ReactNode;
  children: React.ReactNode;
  tooltipClassName?: string;
  withBackground?: boolean;
  isShowTriangle?: boolean;
}

const Tooltip = ({
  label,
  children,
  tooltipClassName,
  withBackground,
  isShowTriangle = false,
}: TooltipProps) => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const handleShowTooltip = () => {
    setTooltipVisible(true);
  };

  const handleHideTooltip = () => {
    setTooltipVisible(false);
  };

  return (
    <>
      {isTooltipVisible && withBackground && (
        <div className="w-screen h-screen z-10 fixed top-0 left-0 bg-reliableBlack/50" />
      )}
      <div
        className="relative inline-block"
        onMouseEnter={handleShowTooltip}
        onMouseLeave={handleHideTooltip}
      >
        {isShowTriangle && isTooltipVisible && (
          <div className="absolute bottom-5 w-0 border-t-[20px] border-t-[#231F20] border-x-[10px] border-x-[white] border-solid"></div>
        )}
        {children}
        {isTooltipVisible && (
          <div
            className={`tooltip bg-reliableBlack text-white p-2 rounded-md shadow-lg z-10 absolute bottom-full left-1/2 transform -translate-x-1/2 ${tooltipClassName}`}
            style={{
              opacity: isTooltipVisible ? 1 : 0,
              transition: 'opacity 0.2s ease-in-out',
            }}
          >
            {label}
          </div>
        )}
        {isTooltipVisible && withBackground && (
          <div className="w-full h-full z-10 top-0 left-0 bg-transparent absolute" />
        )}
      </div>
    </>
  );
};

export default Tooltip;
